import type { Colors, DefaultTheme } from 'styled-components';
import { mapDarkTheme } from './DarkTheme';

const colors: Colors = {
  primary: {
    lighten: '#9844b5',
    default: '#793690',
    dim: 'rgba(121,54,144,0.4)',
    mute: 'rgba(121,54,144,0.1)',
  },
  gray: {
    main: '#0e0d24',
    '100': '#ffe',
    '000': '#000',
    '010': '#070707',
    '020': '#1c1b30',
    '030': '#2a2a3c',
    '040': '#393848',
    '050': '#403f4e',
    '060': '#4a4956',
    '070': '#5b5a64',
    '080': '#868689',
    '090': '#a8a7a5',
  },
  green: {
    lighten: '#24a349',
    default: '#1b7936',
    dim: 'rgba(27,121,54,0.4)',
    mute: 'rgba(27,121,54,0.1)',
  },
  red: {
    lighten: '#e43942',
    default: '#ce1c25',
    dim: 'rgba(206,28,37,0.4)',
    mute: 'rgba(206,28,37,0.1)',
  },
  yellow: {
    lighten: '#d79566',
    default: '#cd793d',
    dim: 'rgba(205,121,61,0.4)',
    mute: 'rgba(205,121,61,0.1)',
  },
  orange: {
    lighten: '#70a1fb',
    default: '#3e80fa',
    dim: 'rgba(62,128,250,0.4)',
    mute: 'rgba(62,128,250,0.1)',
  },
  blue: {
    lighten: '#61a8f0',
    default: '#338EEB',
    dim: 'rgba(51,142,235,0.4)',
    mute: 'rgba(51,142,235,0.1)',
  },
  purple: {
    lighten: '#a778e2',
    default: '#8B4ED9',
  },
  white: {
    default: '#f8f8fa',
    dim: 'rgba(248,248,250,0.4)',
    mute: 'rgba(248,248,250,0.1)',
  },
  black: {
    default: '#0e0d24',
    dim: 'rgba(14,13,36,0.4)',
    mute: 'rgba(14,13,36,0.1)',
  },
};

export const DarkMarexTheme: DefaultTheme = mapDarkTheme(colors, {
  name: 'DarkMX',
});
